import { Fragment } from 'react/jsx-runtime'
import { Outlet } from 'react-router-dom'

import { PageHeader } from '@/components/shared/navigation/PageHeader'

export default function Component() {
  return (
    <Fragment>
      <PageHeader
        title="Chamados"
        items={[
          { title: 'Todos', path: 'todos' },
          { title: 'Meus chamados', path: 'meus-chamados' },
        ]}
      />

      <Outlet />
    </Fragment>
  )
}
